// @ts-nocheck

import React, { useCallback, useMemo } from 'react';
import { createPortal } from 'react-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { menuActionCreators, userActionCreators } from '../../actions';
import { externalLinkOpen } from '../../actions/externallink';
import { actions as loginActionCreators } from '../../actions/login';
import { getAppDOMElement } from '../../DOMElements';
import useMergeProps from '../../hooks/useMergeProps';
import { isLibrary } from '../../lib/useragent';
import { isGrids } from '../../modules/grids/utils/routes';
import FloatingWtv from '../FloatingWtv';
import FloatingWtvProvider from '../FloatingWtvProvider';
import NavigationDesktopBarContainer from '../NavigationDesktopBar/NavigationDesktopBarContainer';

import DesktopLayout from './DesktopLayout';
import selectDesktopLayoutProps from './DesktopLayout.selector';

type DesktopLayoutContainerProps = {
  className?: string;
};

const DesktopLayoutContainer = (ownProps: DesktopLayoutContainerProps) => {
  const { isWTVEnabled, ...selectedProps } = useSelector(selectDesktopLayoutProps);

  const dispatch = useDispatch();
  const location = useLocation();
  const isGridsRoute = isGrids(location.pathname);

  const handlePanicButtonPress = useCallback(() => {
    dispatch(loginActionCreators.banDeUser({ jwt: selectedProps.jwt, sessionId: selectedProps.sessionId }));
  }, [dispatch, selectedProps]);

  const openExternalLink = useCallback(
    (url, options) => {
      dispatch(externalLinkOpen(url, options));
    },
    [dispatch],
  );

  const clearLivePreferences = useCallback(() => {
    dispatch(userActionCreators.clearPreferences('live'));
  }, [dispatch]);

  const menuReset = useCallback(() => {
    dispatch(menuActionCreators.menuReset());
  }, [dispatch]);

  const otherProps = useMemo(
    () => ({
      menuReset,
      handlePanicButtonPress,
      openExternalLink,
      clearLivePreferences,
    }),
    [clearLivePreferences, handlePanicButtonPress, openExternalLink, menuReset],
  );

  const enhancedProps = useMergeProps({ ownProps, selectedProps, otherProps });

  return (
    <FloatingWtvProvider>
      {isLibrary ? <NavigationDesktopBarContainer /> : null}
      <DesktopLayout {...enhancedProps} />
      {!isGridsRoute && isWTVEnabled && !isLibrary ? createPortal(<FloatingWtv />, getAppDOMElement()) : null}
    </FloatingWtvProvider>
  );
};

export default DesktopLayoutContainer;
